import { t } from "@/i18n-js/instance";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";
import { BaseRedirectLinkContainer } from "@circle-react/components/OnboardingComponents/BaseRedirectLinkContainer";

export const SignupLink = () => {
  const {
    signUpOptions,
    currentCommunityPolicies: { showSignupLink },
  } = useCurrentCommunityContext();

  if (!showSignupLink) {
    return null;
  }

  return (
    <BaseRedirectLinkContainer>
      {signUpOptions.label}{" "}
      <a href={signUpOptions.url}>
        {t("authentication_app.shared_links.do_not_have_account.link")}
      </a>
    </BaseRedirectLinkContainer>
  );
};
